var map = {
	"./43.mp3": "5441",
	"./44.mp3": "f0a1",
	"./45.mp3": "4eaf",
	"./46.mp3": "70be",
	"./47.mp3": "9423",
	"./48.mp3": "0a28",
	"./49.mp3": "15f0",
	"./50.mp3": "26b4",
	"./51.mp3": "c540",
	"./52.mp3": "5c1e",
	"./53.mp3": "6cb0",
	"./54.mp3": "ca29",
	"./55.mp3": "4b3b",
	"./56.mp3": "33712",
	"./M_Brilliant.mp3": "06f6",
	"./M_Excellent.mp3": "41d7",
	"./M_Fantastic.mp3": "7bfe",
	"./M_Great.mp3": "e431",
	"./M_Perfect.mp3": "fa4b",
	"./M_Think again.mp3": "52e1",
	"./M_Try again.mp3": "9d63",
	"./M_Very good.mp3": "be35",
	"./M_Well done.mp3": "58ec",
	"./M_Work harder.mp3": "886e",
	"./click.mp3": "e368",
	"./false.mp3": "7159",
	"./true.mp3": "1a4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "62ce";